import { ControlBarButton, ControlBarButtonProps } from "@azure/communication-react";
import React from "react";
import { Icon } from "@fluentui/react";


interface ControlBarChatButtonProps extends ControlBarButtonProps {
    onClick: () => void;
    checked: boolean;
    onRenderOnIcon?: () => JSX.Element;
    onRenderOffIcon?: () => JSX.Element;
}

export const ControlBarChatButton = (props: ControlBarChatButtonProps) => {

    const DefaultOnIcon = () => <Icon iconName="ControlBarChatButtonActive" />;
    const DefaultOffIcon = () => <Icon iconName="ControlBarChatButtonInactive" />;

    return (
        <ControlBarButton
            {...props}
            label={'Chat'}
            onClick={() => {
                props.onClick();
            }}

            toggle={true}
            checked={props.checked}
            onRenderOnIcon={props.onRenderOffIcon ?? DefaultOnIcon}
            onRenderOffIcon={props.onRenderOffIcon ?? DefaultOffIcon}
        />
    );
}
